<template>
    <div class="serve_main" ref="list">
      <div class="moreMsg" @click="getMoreMsg">查看更多</div>
      <div
        class="message_warp"
        v-for="(item, index) in messageList"
        :key="index"
      >
        <!-- 我的信息 -->
        <my-chat
          v-if="item.send_from === 1 || item.send_from === 3"
          :time="item.create_time"
          :avatar="item.headimgurl"
          :con="item.content"
          :name="item.nickname ? item.nickname : '匿名'"
          :msg_type="item.msg_type"
          :message="item"
        ></my-chat>
        <!-- 提示信息 -->
        <!-- <div v-else-if="item.send_from === 4" class="robotMsg">{{ item.content }}</div> -->
        <!-- 客服信息 -->
        <other-chat
          v-else
          :time="item.create_time"
          :avatar="item.headimgurl"
          :con="item.content"
          :name="item.nickname ? item.nickname : '匿名'"
          :msg_type="item.msg_type"
          :message="item"
        ></other-chat>
      </div>
    </div>
</template>

<script>
import sessionAPI from '@/api/session.js'
import OtherChat from ".//components/otherChat";
import MyChat from ".//components/myChat";

export default {
  title: '历史记录',
  name: 'historyRecord',
  components: {
    OtherChat,
    MyChat,
    
  },
  data() {
    return {
      curHeight: 0,
      messageList: [],
      page: 1,
      limit: 20
    }
  },
  methods: {
    getMoreMsg() {
      const sign = this.$route.query.sign
      this.page += 1
      sessionAPI.getHistorySession({
      sign: sign,
      page: this.page,
      limit: this.limit
    }).then(res => {
      if(res.length > 0) {
        //去除标签
        res.forEach(i => {
          if(i.content.indexOf('/emoji') === -1) {
            i.content = i.content.replace(/<[^>]+>/g,"")
          }
        })
        this.messageList.unshift(...res.reverse())
      } else {
        this.$store.commit('showMessage', {
          type: 'error',
          message: '没有更多信息了'
      })
      }
    }).catch(err => {
      this.$store.commit('showMessage', {
          type: 'error',
          message: err
      })
    })
    },
    scrollToBtm() {
      document.documentElement.scrollTop = document.documentElement.scrollHeight + window.innerHeight
    }
  },
  created() {
    const sign = this.$route.query.sign
    sessionAPI.getHistorySession({
      sign: sign,
      page: this.page,
      limit: this.limit
    }).then(res => {
      console.log(res);
      //去除标签
      res.forEach(i => {
        if(i.content.indexOf('/emoji') === -1) {
          i.content = i.content.replace(/<[^>]+>/g,"")
        }
      })
      this.messageList = res.reverse()
    }).catch(err => {
      this.$store.commit('showMessage', {
          type: 'error',
          message: err
      })
    })
  },
  mounted() {
    setTimeout(() => {
      this.scrollToBtm()
    }, 300);
  },
}

</script>

<style lang="less" scoped>
.serve_main {
  padding: 15px 15px 15px;
  // overflow: hidden;
  overflow-y: scroll;
  height: 100%;
}
/deep/.avatar_warp {
  width: 40px;
  height: 40px;
}
.robotMsg {
  padding: 8px 8px 8px 9px;
  line-height: 18px;
  background-color: #f6f6f6;
  margin: 10px auto;
  text-align: center;
  max-width: 310px;
  font-size: 12px;
}
.moreMsg {
  color: #007eed;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
}
/deep/.emoji img {
  width: 30px!important;
  position: relative;
  top: 3px;
}
/deep/.avatar img {
  width: 40px;
}
</style>